"use strict";

exports.flag = Symbol("flag");
exports.properties = Symbol("properties");



//////////////////
// WEBPACK FOOTER
// ./node_modules/_jsdom@13.2.0@jsdom/lib/jsdom/living/xmlhttprequest-symbols.js
// module id = HW7a
// module chunks = 0